import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CancelIcon = () => {
  return <FontAwesomeIcon icon="fa-solid fa-xmark" />;
};

export default CancelIcon;
